import { Grid } from '@mui/material';
import React from 'react';

interface StatusLabelProps {
  color: {
    color: string;
    backgroundColor: string;
  };
  text: string;
}

export default function StatusLabel({ color, text }: StatusLabelProps) {
  return (
    <Grid
      style={{ ...color }}
      className={`h-[22px] rounded-3`}
      display='flex'
      marginY={'auto'}
      justifyContent={'center'}
      item
      px={1}
    >
      <p className='my-auto text-sm font-medium'>{text}</p>
    </Grid>
  );
}
